import apiFetch from '../../../utils/apiFetch';

/** Spends Stroke of Luck (Rogue 20) for one failed roll made on the sheet; the same requestId replays. */
export const claimStrokeOfLuck = async (characterId, { requestId, kind }) => {
  const response = await apiFetch(`/characters/${encodeURIComponent(characterId)}/rogue/stroke-of-luck`, {
    method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ requestId, kind }),
  });
  const result = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(result.message || 'Stroke of Luck could not be used.');
  return result;
};

/** The character with Stroke of Luck's new state. */
export const withStrokeOfLuck = (character, strokeOfLuck) => (character && strokeOfLuck
  ? { ...character, classState: { ...character.classState, rogue: { ...character.classState?.rogue, strokeOfLuck } } } : character);
